module.exports = __webpack_public_path__ + "static/media/platform.53b119a6.png";